import type { ExternalToast } from 'sonner';

/**
 * The Toaster's default `classNames.toast` is merged onto every toast's wrapper, so a custom
 * card would get a second border, background and shadow around its own — these cancel them.
 */
export function customToastOptions(duration: number): ExternalToast {
  return {
    duration,
    unstyled: true,
    classNames: {
      toast: '!rounded-none !border-0 !bg-transparent !p-0 !shadow-none !backdrop-blur-none',
    },
  };
}
